import CreateChatbot from "../components/CreateChatbot";
import Header from "../components/Header";
import InterfaceSettings from "../components/InterfaceSettings";

const Settings = () => {
  return (
    <div className="min-h-screen bg-[#0f172a]">
      <Header
        title=" Enterprise RAG Settings"
        subtitle=" Phase 3: RAG-Powered"
      />
      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <h2 className="text-white text-lg font-medium mb-6 mt-4">Settings</h2>

        <InterfaceSettings />
        <CreateChatbot/>
      </main>
    </div>
  );
};

export default Settings;
